import columnsValues from "../components/HTable/columnsValues";
import formatDate from "./formatDate";

export default {
    mixins: [
        formatDate
    ],

    methods: {
        getBillPeriod(destination, service) {
            // TODO при рефакторе сделать модель Bill и в нее добавить accessor с этим методом
            if (!service || !service.valid_until) {
                return ''
            }

            if (!destination) {
                return `${this.formatDate(service.valid_from, 'DD.MM.YYYY')} - ${this.formatDate(service.valid_until, 'DD.MM.YYYY')}`
            }

            const dates = destination.match(/\d{1,2}\.\d{1,2}\.\d{1,4}/gmi)

            if (!dates) {
                return ''
            }

            return dates.join(' - ')
        },

        getBillStatus(status) {
            const billStatus = columnsValues.billStatuses.filter(billStatus => billStatus.value === status)[0]

            return billStatus ? billStatus.label : status
        },
    }
}


// WEBPACK FOOTER //
// ./resources/assets/js/mixins/billService.js